import api from './';
import { AxiosResponse } from 'axios';

export interface SearchRequest {
  query: string;
  dataTypes?: string[];
  campaignId?: string;
  sessionId?: string;
  playerName?: string;
  limit?: number;
}

export interface SearchResult {
  id: string;
  content: string;
  score: number;
  type: 'campaigns' | 'sessions' | 'transcripts' | 'summaries' | 'recaps' | 'players' | 'documents';
  metadata: {
    sessionId?: string;
    campaignId?: string;
    speaker?: string;
    timestamp?: Date;
    title?: string;
    campaignTitle?: string;
    sessionTitle?: string;
    playerName?: string;
    summaryType?: string;
    documentId?: string;
  };
  dbInfo?: {
    campaign?: {
      id: string;
      title: string;
    };
    session?: {
      id: string;
      title: string;
      startDate?: Date;
      endDate?: Date;
    };
    transcript?: {
      id: string;
      timestamp: Date;
      speaker: string;
    };
    summary?: {
      id: string;
      content: string;
      createdDate: Date;
    };
  };
}

export interface SearchResponse {
  query: string;
  filters: {
    dataTypes?: string[];
    campaignId?: string;
    sessionId?: string;
    playerName?: string;
  };
  resultCount: number;
  results: SearchResult[];
}

export const searchAll = async (searchRequest: SearchRequest): Promise<SearchResponse> => {
  const response = await api.post<SearchRequest, AxiosResponse<SearchResponse>>(
    '/search',
    searchRequest
  );
  return response.data;
};
